import PromoInfo from './PromoInfo.container';

export default PromoInfo;
